"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundSwitchTrackerUILegacy = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../shared/core");
var Timeline_1 = require("../../../../../shared/core/components/Timeline/Timeline");
var Timeline_styled_1 = require("../../../../../shared/core/components/Timeline/Timeline.styled");
var supplies_1 = require("../../../../../shared/core/utils/supplies");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var icons_1 = require("../../../pages/MoveOutConfirm/ui/components/icons");
var sandwich_ids_1 = require("../../../sandwich-ids");
var utils_1 = require("../../../utils");
var InboundSwitchTrackerUILegacy = function (_a) {
    var _b, _c;
    var supply = _a.supply, openingMeterReadings = _a.openingMeterReadings;
    var _d = (0, core_1.useComponents)(), Heading1 = _d.Heading1, PrimaryCTALink = _d.PrimaryCTALink, P = _d.P;
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _e.Copy, copy = _e.copy;
    var meterReads = (0, core_1.useLinks)().meterReads;
    var supplyStartDate = (0, date_fns_1.startOfDay)(supply.start).toISOString();
    var hasSubmittedOmrs = (0, react_1.useMemo)(function () {
        return !!openingMeterReadings.filter(function (read) { return read.fuel === supply.fuel; }).length;
    }, [openingMeterReadings, supply.fuel]);
    var omrWindowStatus = (0, react_1.useMemo)(function () { return (0, supplies_1.getOMRWindowStatus)(supplyStartDate); }, [
        supplyStartDate,
    ]);
    var onboardingStatus = (0, react_1.useMemo)(function () {
        return (0, utils_1.getOnboardingStatus)({
            supplyStartDate: supplyStartDate,
            omrWindowStatus: omrWindowStatus,
            hasSubmittedOmrs: hasSubmittedOmrs,
        });
    }, [hasSubmittedOmrs, omrWindowStatus, supplyStartDate]);
    var analytics = (0, react_1.useMemo)(function () { return analyticsSubjects(onboardingStatus); }, [
        onboardingStatus,
    ]);
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.VIEW_INBOUND_SWITCH_TRACKER, properties: (_b = {
                currentStage: analytics.stage,
                currentStageStatus: analytics.status
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) },
        react_1.default.createElement("div", { "data-testid": "inbound-switch-tracker" },
            react_1.default.createElement(Heading1, null, "Your switch is under way"),
            react_1.default.createElement(Timeline_styled_1.Timeline, null,
                react_1.default.createElement(Timeline_1.TimelineItem, { title: "You told us you want to switch", state: onboardingStatus.switchRequest, key: analytics_subjects_1.SWITCH_STAGES.REQUESTED, testId: "switch-tracker-item-".concat(analytics_subjects_1.SWITCH_STAGES.REQUESTED) }),
                react_1.default.createElement(Timeline_1.TimelineItem, { title: copy('switchTracker.initiatedTitle'), Icon: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.inboundSwitchTracker.started },
                        react_1.default.createElement(icons_1.SwitchStartedImage, null)), state: onboardingStatus.switchingInitiated, key: analytics_subjects_1.SWITCH_STAGES.STARTED, testId: "switch-tracker-item-".concat(analytics_subjects_1.SWITCH_STAGES.STARTED) }),
                react_1.default.createElement(Timeline_1.TimelineItem, { title: copy('switchTracker.onSupplyTitle'), Icon: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.inboundSwitchTracker.onSupply },
                        react_1.default.createElement(icons_1.HouseImage, null)), context: (0, date_fns_1.format)(supply.start, 'd MMM'), state: onboardingStatus.onSupply, key: analytics_subjects_1.SWITCH_STAGES.ON_SUPPLY, testId: "switch-tracker-item-".concat(analytics_subjects_1.SWITCH_STAGES.ON_SUPPLY) }),
                react_1.default.createElement(Timeline_1.TimelineItem, { title: copy('switchTracker.omrSubmitTitle'), Icon: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.inboundSwitchTracker.omrDue },
                        react_1.default.createElement(icons_1.MeterImage, null)), state: onboardingStatus.OMRRequested, context: "".concat((0, date_fns_1.format)(omrWindowStatus.startDate, 'd MMM'), " - ").concat((0, date_fns_1.format)(omrWindowStatus.endDate, 'd MMM')), key: analytics_subjects_1.SWITCH_STAGES.OMR_DUE, testId: "switch-tracker-item-".concat(analytics_subjects_1.SWITCH_STAGES.OMR_DUE) }, omrWindowStatus.isBeforeWindow ? (react_1.default.createElement(Copy, { copyKey: "switchTracker.beforeOMRWindow" })) : omrWindowStatus.isDuringWindow && !hasSubmittedOmrs ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Copy, { copyKey: "switchTracker.omrSubmissionRequired" }),
                    react_1.default.createElement(P, null,
                        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CLICK_OMR_SUBMIT, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                            react_1.default.createElement(PrimaryCTALink, { href: meterReads() },
                                react_1.default.createElement(Copy, { copyKey: "switchTracker.omrLinkText" })))))) : hasSubmittedOmrs ? (react_1.default.createElement(Copy, { copyKey: "switchTracker.omrSubmitted", values: { numberOfDays: '5' } })) : null)))));
};
exports.InboundSwitchTrackerUILegacy = InboundSwitchTrackerUILegacy;
var analyticsSubjects = function (onboardingStatus) {
    if (onboardingStatus.switchRequest === 'done' &&
        onboardingStatus.switchingInitiated === 'coming-up') {
        return {
            status: onboardingStatus.switchRequest,
            stage: analytics_subjects_1.SWITCH_STAGES.REQUESTED,
        };
    }
    if (onboardingStatus.switchingInitiated === 'in-progress') {
        return {
            status: onboardingStatus.switchingInitiated,
            stage: analytics_subjects_1.SWITCH_STAGES.STARTED,
        };
    }
    if (onboardingStatus.OMRRequested === 'in-progress') {
        return {
            status: onboardingStatus.OMRRequested,
            stage: analytics_subjects_1.SWITCH_STAGES.OMR_DUE,
        };
    }
    if (onboardingStatus.OMRRequested === 'done') {
        return {
            status: onboardingStatus.OMRRequested,
            stage: analytics_subjects_1.SWITCH_STAGES.OMR_GIVEN,
        };
    }
    if (onboardingStatus.onSupply === 'done') {
        return {
            status: onboardingStatus.onSupply,
            stage: analytics_subjects_1.SWITCH_STAGES.ON_SUPPLY,
        };
    }
    return {
        status: onboardingStatus,
        stage: analytics_subjects_1.SWITCH_STAGES.ERROR,
    };
};
